import axios from "axios";
import { API_URL } from "./config";

// One letterhead per event, keyed by the event's _id (not its eventId field).
const LH = () => `${API_URL}/letterhead`;

// Let 4xx responses through so callers can branch on the status the guide documents.
const allowClientErrors = { validateStatus: (status) => status < 500 };

const failure = (res) => {
  const error = new Error((res.data && res.data.message) || `Request failed (${res.status})`);
  error.status = res.status;
  return error;
};

// Returns the letterhead, or null when the event has none yet.
export async function getEventLetterhead(eventId) {
  const res = await axios.get(`${LH()}/event/${eventId}`, allowClientErrors);
  if (res.status === 404) return null;
  if (res.status !== 200) throw failure(res);
  return res.data;
}

export async function createLetterhead(eventId, title, content) {
  const res = await axios.post(LH(), { eventId, title, content }, allowClientErrors);
  if (res.status === 409) return getEventLetterhead(eventId);
  if (res.status !== 201) throw failure(res);
  return res.data;
}

// changes holds only the fields that changed.
export async function updateLetterhead(id, changes) {
  const res = await axios.patch(`${LH()}/${id}`, changes, allowClientErrors);
  if (res.status !== 200) throw failure(res);
  return res.data;
}

export async function deleteLetterhead(id) {
  const res = await axios.delete(`${LH()}/${id}`, allowClientErrors);
  if (res.status !== 204 && res.status !== 404) throw failure(res);
}

// phones is optional: leave it out to send to the event's phone.
export async function sendLetterhead(id, phones) {
  const res = await axios.post(`${LH()}/${id}/send`, phones ? { phones } : {}, allowClientErrors);
  if (res.status !== 200) throw failure(res);
  return res.data;
}

export const letterheadPdfUrl = (id) => `${LH()}/${id}/pdf`;

// A 200 from send only means MSG91 got the request; this reads its result.
export function describeSendResult(result) {
  const text = String(result || "");
  if (text === "WhatsApp disabled") {
    return { sent: false, message: "Not sent: WhatsApp is disabled on this server" };
  }
  if (text === "No valid 10-digit phone numbers") {
    return { sent: false, message: "Not sent: add a 10-digit mobile number" };
  }
  try {
    const parsed = JSON.parse(text);
    if (parsed && parsed.status === "success") return { sent: true, message: "Sent on WhatsApp" };
  } catch (error) {
    // Not JSON, so it's an error string from MSG91.
  }
  return { sent: false, message: `Send failed: ${text || "no response from WhatsApp"}` };
}
